var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"todo-main"},[_c('transition-group',{attrs:{"name":"todo","appear":""}},_vm._l((_vm.todos),function(todoObj){return _c('TodoItem',{key:todoObj.id,attrs:{"todo":todoObj}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }